<template lang="html">
    <div class="modal-mask" @click="close" v-show="this.$store.getters.contentShow" transition="modal">
        <div class="modal-container" @click.stop>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['onClose'],
    methods: {
        close() {
            this.onClose();
        }
    },
    created() {
        document.addEventListener("keydown", (e) => {
            if (this.$store.getters.contentShow && e.keyCode == 27) {
                this.onClose();
            }
        });
    }
}
</script>

<style lang="scss">
@import "../../assets/resources/css/partials/variables";

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
    width: 35%;
    @media only screen and (max-width: $medium-screen) {
        width: 85%;
    }

    margin: 15% auto 0;

    @media only screen and (max-width: $medium-screen) {
        margin: 125px auto 0;
    }

    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-enter, .modal-leave {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// Modal.vue?6ca14c5f